document.addEventListener("DOMContentLoaded", function() {

	let param = window.location.search.replace('?','');
		param = param.replace('/','');

	const collapsible = document.getElementsByClassName('collapsible');

	for (var i = collapsible.length - 1; i >= 0; i--) {
		for (var j = collapsible[i].childNodes.length - 1; j >= 0; j--) {

			if(collapsible[i].childNodes[j].nodeName == "DT"){
				collapsible[i].childNodes[j].querySelectorAll('button')[0].addEventListener('click', function(){

					this.parentNode.classList.toggle('expanded');

					console.log( this.parentNode.classList.contains('expanded') );
					this.parentNode.nextElementSibling.toggleAttribute('hidden');
				});
			}
		}
	}

	let timeout;
	let carousel = document.querySelector('.carousel');
	let carouselOptions = {
		prevNextButtons: false,
		wrapAround: true,
		contain: true
	}

	if(carousel){
		let flkty;

		if(window.outerWidth < 600){
			flkty = new Flickity( carousel, carouselOptions);
		}

		window.addEventListener('resize', function( event ){
			if(!timeout){
				timeout = setTimeout(function() {
					// Reset timeout
					timeout = null;

					if( window.outerWidth > 599){
						if(typeof flkty !== 'undefined') {
							console.log(flkty);
							flkty.destroy();
						}
					}
					else{
						// if(typeof flkty === 'undefined') {
							flkty = new Flickity( carousel, carouselOptions);
						// }
					}
				}, 66);
			}
		});

	}

	if(param){
		let target = document.getElementById(param);
		let event = new MouseEvent('click', {
			bubbles: true,
			cancelable: true,
			view: window
		});

		if(target){
			target.dispatchEvent(event);

			window.scrollTo({
				'behavior': 'smooth',
				'left': 0,
				'top': target.offsetTop
			});
		}
	}

});